<template lang='pug'>
  div(v-resize='onResize' :id='editorId')
</template>

<script>
import _ from 'lodash';
import * as monaco from 'monaco-editor';

export default {
  name: 'BionicMetricsMonacoSimpleEditor',
  props: {
    mode: {
      type: String,
      default: 'javascript'
    },
    theme: {
      type: String,
      default: 'vs-dark'
    },
    value: {
      default() {
        return '';
      }
    }
  },
  async mounted() {
    this.editorId = `editor-${this.randomNumber(5)}`;
    this.$nextTick(() => {
      this.monacoModel = monaco.editor.createModel(this.value, this.mode);
      this.editor = monaco.editor.create(document.getElementById(this.editorId), {
        model: this.monacoModel,
        language: this.mode,
        theme: this.theme
      });
      this.monacoModel.onDidChangeContent(_.debounce(this.valueChanged, 300, {leading: true}));
    });
  },
  beforeDestroy() {
    console.log('Disposing of editor');
    this.editor.dispose();
  },
  methods: {
    // eslint-disable-next-line
    onResize: _.debounce(function () {
      this.editor.layout();
    }, 250),
    set(value) {
      this.monacoModel.setValue(value);
    },
    valueChanged() {
      this.$emit('input', this.monacoModel.getValue());
    },
    randomNumber(digits) {
      // eslint-disable-next-line
      return Math.floor(Math.pow(10, digits - 1) + Math.random() * (Math.pow(10, digits) - Math.pow(10, digits - 1) - 1));
    }
  },
  mixins: [],
  data() {
    return {
      uri: null,
      initialSet: true,
      editorId: 'editor',
      editor: null,
      monacoModel: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
